// Path: ./src/app/pages/CreateFlyerItemListPage/styled.ts
import styled from "styled-components";
import { Button, ButtonProps, styled as MuiStyled } from "@mui/material";

export const LeftButtonSection = styled.div``;
export const RightSearchSection = styled.div`
  flex: 0 500px;
`;

export const TableWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;
export const CopyButton = MuiStyled(Button)<ButtonProps>(() => ({
  color: "#ff8038",
  backgroundColor: "transparent",
  borderColor: "transparent",
  textTransform: "capitalize",
  fontSize: "13px",
  "&:hover": {
    backgroundColor: "#ff8038",
    color: "#ffff !important",
    borderColor: "#ff8038",
  },
}));

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
`;
